export function fmtPct(value) {
  const n = Number(value || 0);
  return `${Math.max(0, Math.min(100, Math.round(n)))}%`;
}

export function fmtScore(value) {
  const n = Number(value || 0);
  return n.toFixed(1);
}

export function initials(name = "") {
  if (!name) return "?";
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export function deltaClass(delta) {
  if (delta > 0) return "up";
  if (delta < 0) return "down";
  return "flat";
}
